<template lang="pug">
  modal(:title='$t("contact.title")' @closeModal='hideElement({ element: "contactModal" })')
    p.subtitle.text-normal.dark-gray.m-top-1
      | {{ $t('contact.subtitle') }}
    form.contact-container(name='contactForm' @submit.prevent='sendMessage' novalidate)
      label.text-normal.name-label
        | {{ $t('contact.name') }}
      input.input-border(
        type='text'
        name='name'
        v-model='name'
        :placeholder='$t("contact.namePlaceholder")'
        :class='{ error: showErrors && $v.name.$invalid }'
        maxlength='150'
      )
      label.text-normal.m4-top-5.name-label
        | {{ $t('contact.email') }}
      input.input-border(
        type='email'
        name='email'
        v-model='email'
        :placeholder='$t("contact.emailPlaceholder")'
        :class='{ error: showErrors && $v.email.$invalid }'
      )
      label.text-normal.name-label.m4-top-5
        | {{ $t('contact.message') }}
      textarea.input-border.message-container(
        type='text'
        name='message'
        v-model='message'
        :placeholder='$t("contact.messagePlaceholder")'
        :class='{ error: showErrors && $v.message.$invalid }'
        maxlength='500'
      )
      .radios-container.row.middle
        .radio.m-right-1(:class='{ error: showErrors && $v.role.$invalid }')
          input.radio-input(type='radio' name='role' v-model='role' :value='$t("contact.teacher")')
          .radio-fill
        label.text-small.dark-gray.m-right-5(for='teacher')
          | {{ $t('contact.teacherPlaceholder') }}
        .radio.m-right-1(:class='{ error: showErrors && $v.role.$invalid }')
          input.radio-input(type='radio' name='role' v-model='role' :value='$t("contact.author")')
          .radio-fill
        label.text-small.dark-gray(for='author')
          | {{ $t('contact.authorPlaceholder') }}
      .row.space-between.middle.width-100
        .errors-container.column
          span.error-desc(v-if='requiredFields')
            | {{ $t('contact.errors.requiredFields') }}
          span.error-desc(v-if='emailFormat')
            | {{ $t('contact.errors.emailFormat') }}
        button.primary-button.self-end(type='submit')
          | {{ $t('contact.send') }}
</template>

<script>
import { mapActions } from 'vuex'
import { i18n } from '@/main'

import { required, email } from 'vuelidate/lib/validators'
import { sendContactForm } from '@/services/EmailService'
import { emailRegex } from '@/utils/validators'
import { successIcon } from '@/assets/ic_check.svg'

import Modal from '../Modal'

export default {
  data: () => ({
    name: '',
    email: '',
    message: '',
    role: '',
    showErrors: false,
    successIcon
  }),
  validations: {
    name: { required },
    email: { required, email, emailRegex },
    message: { required },
    role: { required }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement'
    ]),
    sendMessage() {
      if (this.$v.$invalid) {
        this.showErrors = true
      } else {
        const { name, email, message, role } = this
        this.showElement({ element: 'fullPageLoader' })
        this.hideElement({ element: 'contactModal' })
        sendContactForm(name, email, message, role).then(response => {
          this.hideElement({ element: 'contactModal' })
          this.hideElement({ element: 'fullPageLoader' })
          this.showErrors = false
          this.showElement({ element: 'successModal',
            props: {
              title: i18n.t('contact.success.title'),
              subtitle: i18n.t('contact.success.subtitle'),
              icon: successIcon,
              showCloseButton: true,
              buttonText: i18n.t('contact.success.doneButton')
            }
          })
        })
      }
    }
  },
  computed: {
    requiredFields() {
      return this.showErrors && (!this.$v.name.required || !this.$v.message.required || !this.$v.role.required || !this.$v.email.required)
    },
    emailFormat() {
      return this.showErrors && (!this.$v.email.email || !this.$v.email.emailRegex)
    }
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>
.contact-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 420px;
  margin-top: 30px;
}

.subtitle {
  max-width: 350px;
}

.radios-container {
  margin: 25px 0;
}

.errors-container {
  flex: 1;
  height: 40px;
}

.message-container {
  padding-top: 15px;
  height: 120px;
  resize: none;
}
</style>
